import React from "react";
import { createPortal } from "react-dom";
import { useResExpiredState, clearResExpired } from "../../Configs/ResExpiredStore";

// Global popup shown whenever ANY api call's error response is the backend's RES_EXPIRED shape
// ({code: "RES_EXPIRED", CodeName: "Results Expired", Message: "..."}) — triggered from
// AxiosConfig.js's shared response interceptor (ResExpiredStore.js), so this fires no matter
// which module/page the stale call came from (Hold, any *CombinedFees() fare-family popup, etc —
// see ResExpiredStore.js's own docblock). Same portal-onto-body, non-closable pattern as
// RateLimitOverlay — per explicit instruction ("yeh popup ko ban nhi kr skte"): no × button, no
// click-outside-to-dismiss — the stale results are genuinely unusable, so "Search Again" (which
// navigates to a fresh homepage search) is the only way out.
function ResExpiredOverlay() {
  const { isShown, message } = useResExpiredState();

  if (!isShown) return null;

  const goSearchAgain = () => {
    clearResExpired();
    window.location.href = "/";
  };

  return createPortal(
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999999,
        backgroundColor: "rgba(0, 0, 0, 0.55)",
        backdropFilter: "blur(2px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pointerEvents: "auto",
      }}
      // swallow any stray clicks on the overlay itself too — not closable by clicking outside
      onClick={(e) => e.stopPropagation()}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          padding: "32px 40px",
          textAlign: "center",
          maxWidth: 420,
          boxShadow: "0 10px 40px rgba(0,0,0,0.35)",
          position: "relative",
          fontFamily: "var(--font-family-averta-regular)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            border: "4px solid #e53935",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 auto 16px",
            fontSize: 32,
            fontWeight: 700,
            color: "#e53935",
          }}
        >
          !
        </div>
        <h2
          style={{
            margin: "0 0 8px",
            fontSize: "1.25rem",
            color: "#222",
            fontFamily: "var(--font-family-averta-bold)",
          }}
        >
          Results Expired
        </h2>
        <p
          style={{
            margin: "0 0 20px",
            color: "#555",
            fontSize: "0.95rem",
            fontFamily: "var(--font-family-averta-regular)",
          }}
        >
          {message}
        </p>
        <button
          type="button"
          onClick={goSearchAgain}
          style={{
            background: "#e53935",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            padding: "8px 20px",
            fontSize: "0.9rem",
            fontWeight: 600,
            cursor: "pointer",
            fontFamily: "var(--font-family-averta-semibold)",
          }}
        >
          Search Again
        </button>
      </div>
    </div>,
    document.body
  );
}

export default ResExpiredOverlay;
